<template>
  <div>

    <field-wrapper label="Filter type" v-model="values.type" :options="options" track-by="value" option-label="label"
                   type="select" :close-on-select="true"
                   :error="errors.type"/>
    <div class="text-muted">
      {{values.type ? values.type.help : 'Select a filter from the dropdown above.'}}
    </div>
  </div>
</template>
<script>
  import fieldWrapper from '@/components/shared/field-wrapper'

  export default {
    components: {
      fieldWrapper
    },
    props: {
      onSubmit: Function,
      values: Object,
      options: Array,
      errors: Object
    },
    name: 'filterSelect'
  }
</script>
<style>
</style>
